<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <form
        @submit.prevent="onSubmit"
        enctype="multipart/form-data"
        id="account-manage-buttons"
      >
        <vx-card title="Edit User">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="''"
                class="w-full"
                v-model="name"
                name="Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{
                errors.first("Name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Role</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-validate="'required'"
                  v-model="role"
                  label="name"
                  item-value="id"
                  :options="list_role"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  name="Role"
                />
                <span class="text-danger text-sm" v-show="errors.has('Role')">{{
                  errors.first("Role")
                }}</span>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required|email'"
                v-model="email"
                class="w-full"
                name="Email"
              />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{
                errors.first("Email")
              }}</span>
              <span class="text-danger text-sm" v-show="email_taken"
                >The email has already been taken.</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="''"
                v-model="password"
                class="w-full"
                name="Password"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Password')"
                >{{ errors.first("Password") }}</span
              >
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios120 from '../../../axios120'
import router from '../../../router'
export default {
  data() {
    return {
      userAuth: JSON.parse(localStorage.getItem('user')),
      id: this.$route.params.userId,
      new_user: null,
      name: '',
      email: '',
      email_taken: false,
      nik: '',
      phone: '',
      id_card_photo: '',
      link_photo: '',
      error_id_card_photo: false,
      role: { id: 1, name: 'Admin' },
      list_role: [{ id: 1, name: 'Admin' }, { id: 0, name: 'Mitra' }],
      password: '',
      colorAlert: 'primary',
      titleAlert: 'Alert',
      activeAlert: false,
      valueInput: '',
      file: null,

    }
  },
  watch: {
    email(newValue, oldValue) {
      this.email_taken = ''

    },


  },
  components: {
    'v-select': vSelect,
    Datepicker
  },
  mounted() {
    this.userId = this.$route.params.userId
    axios120.get('ecommerce/web/user/' + this.userId, {})
      .then(res => {
        if (res.status != 200) {
          console.log(res)

        } else {
          this.name = res.data.nama_panjang
          res.data.role == 4 ? this.role = { id: 4, name: 'Mitra' } : { id: 3, name: 'Admin' }
          this.email = res.data.email
          console.log(res)
        }


      })
      .catch(error => {
        console.log(error.response)

      })

  },

  methods: {
    onFileSelected(event) {
      this.id_card_photo = event.target.files[0]
      console.log(this.id_card_photo)

    },
    onSubmit() {
      // var formData = new FormData();
      // formData.append('id', this.id)
      // formData.append('name', this.name)

      // formData.append('email', this.email)
      var formData = {

        'id': this.id,
        'nama_panjang': this.name,
        'email': this.email,
        'password': this.password,
        'role_id': this.role.id
      }

      //   formData.append('password', this.password)
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.error_id_card_photo) {
            return
          }
          this.$vs.loading()
          axios120.put('/ecommerce/web/user', formData)
            .then(res => {
              if (res.status != 200) {
                this.$vs.loading.close()
                this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
              } else {
                this.$vs.loading.close()
                this.acceptAlert('success', 'Berhasil', 'Success edit user')
                router.push('/user')

              }


            })
            .catch(error => {
              this.email_taken = error.response.data.message
              this.$vs.loading.close()
            })
        } else {
          this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },


  }
}
</script>
